import angular from 'angular';
import Home from './home/home';
import Login from './login';
import Main from './main/main';
import Sidemenu from './sidemenu';
import Users from './users/users';
import Signup from './signup';
import ChangePassword from './change-password/change-password';
import ForgotPassword from './forgot-password/forgot-password';
import ResetPassword from './reset-password/reset-password';

import Clients from './clients/clients';
import Client from './client/client';

import Employees from './employees/employees';
import Employee from './employee/employee';

import BankTx from './banktx/banktx';
import BankTxes from './banktxes/banktxes';
import BankTxBulk from './banktx-bulk/banktx-bulk';

import Receipt from './receipt/receipt';
import Receipts from './receipts/receipts';
import GIReceipt from './receipt/groupinvoice/receipt';

import Check from './check/check';
import Checks from './checks/checks';

import Collection from './collection/collection';
import Collections from './collections/collections';
// import CollectionItem from './collection-item/collection-item';
//import PaymentItem from './payment-item/payment-item';

import Procedures from './procedures/procedures';
import Procedure from './procedure/procedure';

import ProcedureTemplates from './procedure-templates/procedure-templates';
import ProcedureTemplate from './procedure-template/procedure-template';
import ItemTemplates from './item-templates/item-templates';
import ItemTemplate from './item-template/item-template';

import Vehicles from './vehicles/vehicles';
import Vehicle from './vehicle/vehicle';

import Quote from './quote/quote';
import Quotes from './quotes/quotes';

import Spending from './spendings/spending/spending';
import Spendings from './spendings/spendings';

import SpendingTypes from './spending-types/spending-types';
import SpendingType from './spending-type/spending-type';

import OperativeSpending from './operative-spendings/operative-spending/operative-spending';
import OperativeSpendings from './operative-spendings/operative-spendings';

import Voucher from './vouchers/voucher/voucher';
import Vouchers from './vouchers/vouchers';
import VoucherCollection from './vouchers/voucher-collection/voucher-collection';

import Worker from './workers/worker/worker';
import Workers from './workers/workers';

import PendingSpendings from './pendingspendings/pendingspendings';
import PendingSpending from './pendingspendings/pendingspending/pendingspending';

import Cashbox from './cashbox/cashbox';

import ClientFilterComponent from './client-filter/client-filter.component';

import Registry from './registries/registry/registry';
import Registries from './registries/registries';

import GroupInvoice from './group-invoices/group-invoice/group-invoice';
import GroupInvoices from './group-invoices/group-invoices';

import CashboxTransfers from './cashbox-transfers/cashbox-transfers';

import Brands from './brands/brands';
import Brand from './brands/brand/brand';

import Creditors from './creditors/creditors';
import Creditor from './creditors/creditor/creditor';

import Agencies from './agencies/agencies';
import Agency from './agencies/agency/agency';

import Salesmen from './salesmen/salesmen';
import Salesman from './salesmen/salesman/salesman';

// Operations stuff
import StatesTemplate from './states-template/states-template';
import StatesTemplates from './states-templates/states-templates';
import OperationType from './operation-type/operation-type';
import OperationTypes from './operation-types/operation-types';
import OperationProcedure from './operation-procedure/operation-procedure';
import Operation from './operation/operation';
import Operations from './operations/operations';
import OperationTasks from './operation-tasks/operation-tasks';

import CitySelectorComponent from './city-selector/city-selector.component';
import ClientAddressComponent from './client-address/client-address.component';

import Cities from './cities/cities';
import City from './cities/city/city';

import Assignations from './assignations/assignations';
import Assignation from './assignation/assignation';

import Fleets from './fleets/fleets';
import Fleet from './fleets/fleet/fleet';

import Tasks from './tasks/tasks';

let componentModule = angular
  .module('app.components', [
    Signup,
    Login,
    Main,
    Home,
    Sidemenu,
    Users,
    ChangePassword,
    ForgotPassword,
    ResetPassword,
    Clients,
    Client,
    Employees,
    Employee,
    BankTx,
    BankTxes,
    BankTxBulk,
    Receipt,
    Receipts,
    GIReceipt,
    Check,
    Checks,
    Collection,
    Collections,
    Procedures,
    Procedure,
    ProcedureTemplates,
    ProcedureTemplate,
    ItemTemplates,
    ItemTemplate,
    Vehicles,
    Vehicle,
    Quotes,
    Quote,
    Spendings,
    Spending,
    SpendingTypes,
    SpendingType,
    OperativeSpending,
    OperativeSpendings,
    Vouchers,
    Voucher,
    VoucherCollection,
    Workers,
    Worker,
    PendingSpendings,
    PendingSpending,
    Cashbox,
    Registries,
    Registry,
    GroupInvoices,
    GroupInvoice,
    CashboxTransfers,
    StatesTemplate,
    StatesTemplates,
    OperationProcedure,
    OperationTasks,
    OperationType,
    OperationTypes,
    Operation,
    Operations,
    Brands,
    Brand,
    Creditors,
    Creditor,
    Agencies,
    Agency,
    Salesmen,
    Salesman,
    Cities,
    City,
    Assignations,
    Assignation,
    Fleets,
    Fleet,
    Tasks,
  ])
  .component('clientFilter', ClientFilterComponent)
  .component('citySelector', CitySelectorComponent)
  .component('clientAddress', ClientAddressComponent).name;

export default componentModule;
